export const ANSWER_LINE_WIDTHS = [
  ['96%', '88%', '54%'],
  ['92%', '72%'],
]

export const QUESTION_WIDTHS = ['46%', '32%']
